import React from "react";
import PropTypes from "prop-types";

const DepartmentHints = ({ classes, hints }) => {
  if (!hints) return null;

  const hasContent =
    (hints.recommended && hints.recommended.length > 0) ||
    (hints.opportunities && hints.opportunities.length > 0);

  if (!hasContent) return null;

  return (
    <div className={classes.hintsBlock}>
      <div className={classes.hintsTitle}>この部門の攻略ヒント</div>

      <div className={classes.hintsListWrapper}>
        {hints.recommended && hints.recommended.length > 0 && (
          <ul className={classes.hintsList}>
            {hints.recommended.map((item, idx) => (
              <li key={"rec-" + idx} className={classes.hintItem}>
                {item}
              </li>
            ))}
          </ul>
        )}

        {hints.opportunities && hints.opportunities.length > 0 && (
          <ul className={classes.hintsList}>
            {hints.opportunities.map((item, idx) => (
              <li key={"opp-" + idx} className={classes.hintItem}>
                {item}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

DepartmentHints.propTypes = {
  classes: PropTypes.object.isRequired,
  hints: PropTypes.shape({
    recommended: PropTypes.array,
    opportunities: PropTypes.array,
  }),
};

DepartmentHints.defaultProps = {
  hints: { recommended: [], opportunities: [] },
};

export default DepartmentHints;



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/parts/DepartmentHints.jsx